import { MunchedImage, MunchedImageProxySize } from 'sb-lib/types';

export const getImageMuncherProxySrc = (
  image: MunchedImage | null | undefined,
  proxySize: MunchedImageProxySize | null,
  fallback?: string,
) => {
  if (!image) return fallback;

  const proxySignedDownloadUrl =
    image.proxies && proxySize && image.proxies[proxySize]?.signedDownloadUrl;

  if (proxySignedDownloadUrl) return proxySignedDownloadUrl;

  return image.signedDownloadUrl;
};
